import { useSetAtom } from 'jotai';
import { featuresAtom } from '../atoms';
export const useSetReviewFeature = () => {
  const setFeatures = useSetAtom(featuresAtom);
  return setFeatures;
};